import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_38: FaireProductEntity = {
  token: "legacy_prod_abbott-38",
  type: "product",
  name: 'All Purpose Scissors Red 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2f05eadb238df5969f4cb4d595068c8f4eef0754e27996a092959d8a6752e3f0.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
